import Cookies from 'js-cookie';
import ApiManager from '../../api/crud-manager';
import fireToastEvent from '../../utils/fire-toastr-message';
import serializeForm from '../../utils/forms/serialize-form';

class RegisterAccount {
  constructor(options = {}) {
    this.config = {
      moduleList: () => document.querySelectorAll('.js-register-account'),
      registerFormInput: (module, inputName) => module.querySelector(`[name="${inputName}"]`),
      notRequiredFormElementsArray: [
        'formregister.SendMail',
        'g-recaptcha-response',
        'nextView',
        'surveyName'
      ],
      apiManager: new ApiManager(),
      ...options
    };
  }

  addInputEventListeners(module) {
    const { registerFormInput } = this.config;
    const emailInput = registerFormInput(module, 'emailAddress');
    const userNameInput = registerFormInput(module, 'username');
    if (emailInput && userNameInput) {
      emailInput.addEventListener('input', e => {
        userNameInput.value = e.target.value;
      });
    }

    const countrySelect = registerFormInput(module, 'country');
    const countryCodeInput = registerFormInput(module, 'countryCode');
    if (countrySelect && countryCodeInput) {
      countrySelect.addEventListener('change', e => {
        countryCodeInput.value = e.target.value;
      });
    }
  }

  addSubmitEventListener(module) {
    module.addEventListener('submit', e => {
      e.preventDefault();
      this.submitForm(module);
    });
  }

  filterPostObject(postObj) {
    const { notRequiredFormElementsArray } = this.config;
    return Object.fromEntries(
      Object.entries(postObj).filter(([key]) => !notRequiredFormElementsArray.includes(key))
    );
  }

  submitForm(module) {
    const { registerFormInput, apiManager } = this.config;
    const submitButton = module.querySelector('[data-child-module="SubmitButton"]');

    $(module)
      .parsley()
      .validate();
    if (submitButton) {
      submitButton.setAttribute('disabled', true);
    }
    const postObj = serializeForm(module);
    const updatedPostObj = this.filterPostObject(postObj);
    const newsLetter = registerFormInput(module, 'Schrijf je in voor de nieuwsbrief');
    if (newsLetter && newsLetter.checked) {
      updatedPostObj.preferences = [{ key: 'newsletter', type: 'bool', value: true }];
    }

    apiManager
      .post('/api/v1/account/register', updatedPostObj)
      .then(response => {
        Cookies.set('token', response.accessToken);
        Cookies.set('security', response.formsTicket);
        if (submitButton) {
          submitButton.removeAttribute('disabled');
        }
        const url = window.location.href;
        const params = url.split('?');

        if (params.length > 1 && params[1].includes('checkout')) {
          window.location = `${module.dataset.checkoutUrl}#/delivery`;
        } else if (params.length > 1 && params[1].includes('returnUrl')) {
          const completeUrl = new URL(window.location.href);
          const searchParams = new URLSearchParams(completeUrl.search);
          window.location = searchParams.get('returnUrl');
        } else {
          window.location = '/';
        }
      })
      .catch(err => {
        if (submitButton) {
          submitButton.removeAttribute('disabled');
        }
        err.json().then(res => {
          fireToastEvent('error', res.modelState[''][0]);
        });
      });
  }

  init() {
    const { moduleList } = this.config;

    moduleList().forEach(_module => {
      const module = _module;
      const { initialized } = module.dataset;

      if (initialized) return;
      module.dataset.initialized = true;
      this.addInputEventListeners(module);
      this.addSubmitEventListener(module);
    });
  }
}

export default RegisterAccount;
